export const getIsLoading = (state) => state.ui.loading;

export const getIsShowModuleSidebar = (state) => state.ui.isShowModuleSideBar;

export const getAlarms = (state) => state.ui.alarms;

// Menu selectors: the application stores the menu in `state.user.menu`.
export const getMenuItems = (state) => state.user?.menu || [];

// Selected menu id is stored under user.selectedMenu (or ui.selectedMenu in some flows)
export const getSelectedMenuId = (state) =>
  state.user?.selectedMenu || state.ui?.selectedMenu || null;
